module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-winner/home-main-modal-winner.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-winner/home-main-modal-winner.component.sass
// module chunks = main